
  document.addEventListener('DOMContentLoaded', () => {
    const footerElement = document.querySelector('footer');
    
    if (!footerElement) {
      console.log('Footer element not found for Intersection Observer.');
      return;
    }
    const observerCallback = (entries) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        document.body.classList.add('footer-visible');
      } else {
        document.body.classList.remove('footer-visible');
      }
    };
    const observer = new IntersectionObserver(observerCallback);
    observer.observe(footerElement);
  });

  
// window.addEventListener('DOMContentLoaded', () => {
//   if (!/^\/collections\//.test(window.location.pathname)) return;
//   // 1. Grab the very first image in .grid-product__image
//   const firstImg = document.querySelector('.product-media img');
//   if (!firstImg) return;

//   // 2. Put its src onto its parent container’s background
//   const container = firstImg.closest('.product-media');
//   container.style.backgroundImage = `url(${firstImg.src})`;

//   // 3. IntersectionObserver to tease only that first image
//   const observer = new IntersectionObserver((entries, obs) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         // 4. Use the Web Animations API for the three-times tease
//         entry.target.animate([
//           { transform: 'translateX(0)' },
//           { transform: 'translateX(-25%)' },
//           { transform: 'translateX(0)' }
//         ], {
//           duration: 2000,
//           easing: 'ease-in-out',
//           iterations: 2,
//           fill: 'forwards'
//         });

//         // 5. Stop observing after the first trigger
//         obs.unobserve(entry.target);
//       }
//     });
//   }, {
//     threshold: 0.1
//   });

//   // 6. Observe that image
//   observer.observe(firstImg);
// });


// Wait for the document to be fully loaded
// document.addEventListener('DOMContentLoaded', (event) => {

//   // 1. Select the section that will eventually contain the prices
//   const targetNode = document.getElementById('meroxio-recently-view-free-slider');

//   // If the target section doesn't exist, stop the script to prevent errors
//   if (!targetNode) {
//     console.error('Recently viewed slider section not found!');
//     return;
//   }

//   // 2. This function will run whenever a change is detected
//   const formatPrices = () => {
//     const priceElements = targetNode.querySelectorAll('.m_recently_viewed_price_text');

//     priceElements.forEach(element => {
//       const originalPrice = element.textContent;

//       // Check if the price exists and needs formatting
//       if (originalPrice && !originalPrice.includes(',')) {
        
//         // --- THIS IS THE NEW LOGIC ---

//         // Step 1: Isolate the number by removing currency symbols and decimals.
//         // "₹18500.00" -> "18500"
//         const numberString = originalPrice.replace('₹', '').replace('.00', '').trim();

//         // Step 2: Use a regular expression to add commas for thousands separators.
//         // "18500" -> "18,500"
//         const formattedNumber = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        
//         // Step 3: Re-assemble the final string with the symbol, space, and formatted number.
//         element.textContent = '₹ ' + formattedNumber;
//       }
//     });
//   };

//   // 3. Create an observer to watch for changes
//   const observer = new MutationObserver(() => {
//     formatPrices();
//   });

//   // 4. Start observing the target node for added child elements
//   observer.observe(targetNode, { childList: true, subtree: true });

//   // Optional: Run it once at the start in case the content is already there
//   formatPrices();
// });

// window.addEventListener('load', function () {

//   function getVariantPicker() {
//     return document.querySelector('variant-picker');
//   }

//   function getCheckedVariant() {
//     const picker = getVariantPicker();
//     if (!picker) return null;

//     return picker.querySelector(
//       'fieldset .variant-option__button-label input:checked'
//     );
//   }

//   function updateSelectedTextState() {
//     const picker = getVariantPicker();
//     if (!picker) return;

//     const selectedText = picker.querySelector('.variant-option__selected-value');
//     if (!selectedText) return;

//     const checkedVariant = getCheckedVariant();

//     if (!checkedVariant) {
//       selectedText.textContent = 'Select a Size';
//       selectedText.classList.add('no-value-selected');
//     } else {
//       selectedText.classList.remove('no-value-selected');
//     }
//   }

//   function updateATCState() {
//     const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
//     const checkedVariant = getCheckedVariant();

//     forms.forEach(form => {
//       const buttons = form.querySelectorAll('button[type="submit"]');
//       buttons.forEach(btn => {
//         btn.disabled = !checkedVariant;
//       });
//     });

//     updateSelectedTextState();
//   }

//   // 🔹 Remove default selection AFTER Horizon initializes
//   setTimeout(() => {
//     const picker = getVariantPicker();
//     if (!picker) return;

//     const radios = picker.querySelectorAll('input[type="radio"]');
//     radios.forEach(radio => radio.checked = false);

//     updateATCState();
//   }, 400);

//   // 🔹 Listen for variant changes
//   document.addEventListener('change', function (e) {
//     if (e.target.closest('variant-picker')) {
//       updateATCState();
//     }
//   });

// });




// window.addEventListener('load', function () {

//   function updateMobileOverlay() {

//     const fixedWrapper = document.querySelector('.fixed-cart-button-mob');
//     if (!fixedWrapper) return;

//     const variantPicker = document.querySelector('variant-picker');
//     if (!variantPicker) return;

//     const checkedVariant = variantPicker.querySelector(
//       'fieldset .variant-option__button-label input:checked'
//     );

//     let overlay = fixedWrapper.querySelector('.atc-overlay-blocker');

//     if (!checkedVariant) {

//       if (!overlay) {
//         overlay = document.createElement('div');
//         overlay.className = 'atc-overlay-blocker';

//         overlay.addEventListener('click', function () {

//   variantPicker.scrollIntoView({
//     behavior: 'smooth',
//     block: 'center'
//   });

//   // Add shine effect
//   const labels = document.querySelectorAll('.variant-option__button-label');

//   labels.forEach(label => {
//     label.classList.add('shine-effect');
//   });

//   // Remove after 2 seconds
//   setTimeout(() => {
//     labels.forEach(label => {
//       label.classList.remove('shine-effect');
//     });
//   }, 3000);

// });


//         fixedWrapper.appendChild(overlay);
//       }

//     } else {
//       if (overlay) overlay.remove();
//     }
//   }

//   setTimeout(() => {
//     updateMobileOverlay();
//   }, 600);

//   document.addEventListener('change', function (e) {
//     if (e.target.closest('variant-picker')) {
//       updateMobileOverlay();
//     }
//   });

// });


// document.addEventListener('click', function(e){

//   const thumb = e.target.closest('#variantThumbnail');

//   if(!thumb) return;

//   const firstThumbnailButton = document.querySelector(
//     '.slideshow-controls__thumbnail'
//   );

//   if(firstThumbnailButton){
//     firstThumbnailButton.click();
//   }

// });
document.addEventListener('DOMContentLoaded', function () {

  const button = document.querySelector('.fixed-cart-button-mob');

  if (!button) return;

  function toggleButton() {
    if (window.scrollY > 20) {
      button.classList.add('show');
    } else {
      button.classList.remove('show');
    }
  }

  toggleButton();

  window.addEventListener('scroll', toggleButton);

});
